/**Les differentes valeurs poss*/ /// </summary>
export enum DefaultTimeValue {
  Now = 'Now',
  Undef = 'Undef',
}
